import _objectSpread from '@babel/runtime-corejs3/helpers/esm/objectSpread2';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/esm/objectWithoutProperties';
import * as React from 'react';

var _excluded = ["title", "titleId"];
var X12 = function X12(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /* @__PURE__ */React.createElement("svg", _objectSpread({
    fill: "none",
    viewBox: "0 0 12 12",
    width: 12,
    height: 12,
    "aria-labelledby": titleId
  }, props), title ? /* @__PURE__ */React.createElement("title", {
    id: titleId
  }, title) : null, /* @__PURE__ */React.createElement("path", {
    fill: "currentColor",
    d: "M9.754 1.477a.563.563 0 0 1 .796.796L6.822 6l3.728 3.727a.563.563 0 0 1-.796.796L6.028 6.795 2.3 10.523a.563.563 0 0 1-.796-.796L5.232 6 1.504 2.273a.563.563 0 0 1 .796-.796l3.728 3.727z"
  }));
};
X12.Size = 12;
X12.Title = "X";

export { X12 as X };
//# sourceMappingURL=X12-87956d6c.js.map
